// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"280":"35f689ed","453":"b03e3c98","564":"0de283e0","665":"5a28d458","725":"f9ffe49b","883":"47c6d6f3","884":"4409721a","987":"1af83fe7"}[chunkId] + ".chunk.js";
};